import { render } from "./formduration.vue?vue&type=template&id=a20b42be&scoped=true"
import script from "./formduration.vue?vue&type=script&lang=js"
export * from "./formduration.vue?vue&type=script&lang=js"

import "./formduration.vue?vue&type=style&index=0&id=a20b42be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20b42be"]])

export default __exports__